import { newsData, suggestionsData } from '../../data';
const reducer = (state, action) => {
  const { type, payload } = action;
  if (type === 'SEARCH_TEXT_CHANGE') {
    // const newSuggestions = suggestionsData.filter(
    //   (suggestion) =>
    //     !state.selectedFilters.includes(suggestion) &&
    //     suggestion.name
    //       .toLowerCase()
    //       .startsWith(payload.target.value.toLowerCase())
    // );
    return {
      ...state,
      //suggestions: newSuggestions,
      searchText: payload.target.value,
    };
  }
  // if (type === 'SUGGESTION_SELECTED') {
  //   const newFilters = [...state.selectedFilters, payload];
  //   const newSuggestions = state.suggestions.filter(
  //     (item) => item.id !== payload.id
  //   );
  //   return {
  //     ...state,
  //     selectedFilters: newFilters,
  //     suggestions: newSuggestions,
  //   };
  // }
  // if (type === 'SUGGESTION_REMOVED') {
  //   const newFilters = state.selectedFilters.filter(
  //     (item) => item.id !== payload.id
  //   );
  //   const newSuggestions = [...state.suggestions, payload];
  //   return {
  //     ...state,
  //     selectedFilters: newFilters,
  //     suggestions: newSuggestions,
  //   };
  // }
  if (type === 'SORT_OPTION_CHANGE') {
    return {
      ...state,
      sortOption: payload.target.value,
    };
  }
  if (type == 'TOGGLE_LIKE') {
    return {
      ...state,
      showLiked: !state.showLiked,
    };
  }
};

export default reducer;
